import axios from "axios";
import swal from "sweetalert";
import router from "@/router";
import {
  errorMessage,
  tokenExpired,
  warningMessageWithoutConfimation
} from "@/api/errorMessages";
import * as api from "@/api/oauth";
import io from "socket.io-client";

export default {
  namespaced: true,
  state: {
    quoteById: null,
    quoteByIdAux: null,
    sendToNonQuote: null,
    customers: null,
    messageHistory: null,
    requote: 0,
    selectedMode: null,
    dataPricingSocket: null,
    infoTablePricing: undefined,
    infoMinPricing: undefined,
    infoMaxPricing: undefined,
    salePrice: [],
    equipmentType: null,
    drayageModes: {
      data: [
        {
          id: "a0k1I0000005eufQAA",
          name: "Drayage",
          ops_dept: "OTR",
          ops_division: "Drayage"
        },
        {
          id: "a0k1I00000B6pAUQAZ",
          name: "Transloading - Drayage",
          ops_dept: "OTR",
          ops_division: "Drayage"
        },
        {
          id: "a0k3s00000bhZi6AAE",
          name: "Reefer Drayage",
          ops_dept: "OTR",
          ops_division: "REEFER"
        }
      ]
    }
  },
  getters: {
    showDrayageModes(state) {
      return state.drayageModes;
    },
    showQuoteById(state) {
      return state.quoteById;
    },
    showQuoteByIdAux(state) {
      return state.quoteByIdAux;
    },
    showModeList(state) {
      return state.sendToNonQuote;
    },
    showSelectedMode(state) {
      return state.selectedMode;
    },
    showInfoTablePricing(state) {
      return state.infoTablePricing;
    },
    showInfoMinPricing(state) {
      return state.infoMinPricing;
    },
    showInfoMaxPricing(state) {
      return state.infoMaxPricing;
    },
    showSalePrice(state) {
      return state.salePrice;
    },
    showEquipmentType(state) {
      return state.equipmentType;
    }
  },
  mutations: {
    setQuoteByIdAux(state, newQuoteById) {
      state.quoteByIdAux = newQuoteById;
    },
    setQuoteById(state, newQuoteById) {
      state.quoteById = newQuoteById;
    },
    quoteSended(state, newQuoteSended) {
      state.quoteSended = newQuoteSended;
    },
    sendToNonQuote(state, modeList) {
      state.sendToNonQuote = modeList;
    },
    setCustomers(state, newCustomers) {
      state.customers = newCustomers;
    },
    setMessageHistory(state, messageHistory) {
      state.messageHistory = messageHistory;
    },
    setRequote(state) {
      state.requote += 1;
    },
    setSelectedMode(state, modeSelected) {
      state.selectedMode = modeSelected?.name;
    },
    setRateValue(state, predictedCost) {
      state.salePrice = [];
      if (predictedCost) {
        if (predictedCost?.length > 0) {
          const organizePredictionArray = predictedCost.sort((a, b) => {
            if (
              a.source.toLowerCase() === "partial" &&
              b.source.toLowerCase() !== "partial"
            ) {
              return -1;
            } else if (
              a.source.toLowerCase() !== "partial" &&
              b.source.toLowerCase() === "partial"
            ) {
              return 1;
            }
            return a.source.localeCompare(b.source);
          });
          organizePredictionArray.forEach(element => {
            state.salePrice.push(Math.round(element.sale_price));
          });
        } else {
          state.salePrice = Math.round(predictedCost.sale_price);
        }
      }
      return state.salePrice;
    },
    setEquipmentType(state, equipmentType) {
      state.equipmentType = equipmentType;
    }
    /* WS */
    /* setDataPricingSocketListener(state, predictedCost) {
      state.infoTablePricing = undefined;
      state.infoMinPricing = undefined;
      state.infoMaxPricing = undefined;
      state.salePrice[predictedCost.haulId] = undefined;
      if (predictedCost?.response) {
        if (predictedCost?.response.length > 0) {
          const index = predictedCost?.response.length - 1;
          state.infoMinPricing =
            predictedCost?.response[index]?.prediction?.min === null
              ? null
              : Math.round(predictedCost?.response[index]?.prediction?.min);
          state.infoMaxPricing =
            predictedCost?.response[index]?.prediction?.max === null
              ? null
              : Math.round(predictedCost?.response[index]?.prediction?.max);
          state.infoTablePricing = predictedCost?.response[index]?.prediction
            ?.message
            ? predictedCost?.response[index]?.prediction
            : predictedCost?.response[index]?.prediction?.predicted_cost ===
              null
            ? null
            : Math.round(
                predictedCost?.response[index]?.prediction.predicted_cost
              );
          state.salePrice[predictedCost.haulId] =
            predictedCost?.response[index].prediction?.sale_price === null ||
            !predictedCost?.response[index].prediction?.sale_price
              ? null
              : Math.round(
                  predictedCost?.response[index]?.prediction?.sale_price
                );
        }
      } else {
        state.dataPricingSocket.on("otr-prediction", function(data) {
          let prediction = JSON.parse(data.prediction);
          if (prediction.prediction?.predicted_cost === undefined) {
            state.infoMinPricing = prediction?.min;
            state.infoMaxPricing = prediction?.max;
            state.infoTablePricing =
              prediction?.predicted_cost || prediction?.prediction;
            state.salePrice[predictedCost.haulId] = prediction.sale_price;
          } else {
            state.infoMinPricing = Math.round(prediction?.prediction?.min);
            state.infoMaxPricing = Math.round(prediction?.prediction?.max);
            state.infoTablePricing = Math.round(
              prediction.prediction.predicted_cost
            );
            state.salePrice[predictedCost.haulId] = Math.round(
              prediction.prediction?.sale_price
            );
          }
        });
      }
    } */
  },
  actions: {
    async getQuote({ commit }, id) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/quote/quote-id/all/${id}/`,
          api.getToken()
        );
        commit("setQuoteByIdAux", response.data);
        if (response.status == 200) {
          commit("setQuoteById", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async sendInfoFTLPricingModel({ commit }, infoHaul) {
      let modes_quoted =
        infoHaul.modesQuoted.length > 1
          ? `${infoHaul.modesQuoted[0]}&modes_quoted=${infoHaul.modesQuoted[1]}`
          : `${infoHaul.modesQuoted[0]}`;
      let payload = infoHaul.pcmiler;
      let haul_id = infoHaul.id;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/infer/otr?haul_id=${haul_id}&modes_quoted=${modes_quoted}`,
          payload,
          api.getToken()
        );
        commit("setRateValue", response?.data);
        return response;
      } catch (err) {
        if (err.response.status === 400)
          warningMessageWithoutConfimation(err.response.data.detail);
        else errorMessage();

        return err.response;
      }
    },
    async getInfoFTLPricingModel({ commit }, haulId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/infer/otr/${haulId}`,
          api.getToken()
        );
        commit("setRateValue", response?.data);
        return response;
      } catch (err) {
        return err.response;
      }
    },
    async sendInfoTCPricingModel({ commit }, infoHaul) {
      let payload = infoHaul.pcmiler;
      let haul_id = infoHaul.id;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/infer/temp-control?haul_id=${haul_id}`,
          payload,
          api.getToken()
        );
        commit("setRateValue", response?.data);
        return response;
      } catch (err) {
        if (err.response.status === 400)
          warningMessageWithoutConfimation(err.response.data.detail);
        else errorMessage();
        return err.response;
      }
    },
    async getInfoTCPricingModel({ commit }, haulId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/infer/temp-control/${haulId}`,
          api.getToken()
        );
        commit("setRateValue", response?.data);
        return response;
      } catch (err) {
        return err.response;
      }
    },
    async sendInfoHHPricingModel({ commit }, infoHaul) {
      let modes_quoted =
        infoHaul.modesQuoted.length > 1
          ? `modes_quoted=${infoHaul.modesQuoted[0]}&modes_quoted=${infoHaul.modesQuoted[1]}`
          : `modes_quoted=${infoHaul.modesQuoted[0]}`;
      let payload = infoHaul.pcmiler;
      let haul_id = infoHaul.id;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/infer/hh?haul_id=${haul_id}&${modes_quoted}`,
          payload,
          api.getToken()
        );
        commit("setRateValue", response?.data);
        return response;
      } catch (err) {
        if (err.response.status === 400)
          warningMessageWithoutConfimation(err.response.data.detail);
        else errorMessage();
        return err.response;
      }
    },
    async getInfoHHPricingModel({ commit }, haulId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/infer/hh/${haulId}`,
          api.getToken()
        );
        commit("setRateValue", response?.data);
        return response;
      } catch (err) {
        return err.response;
      }
    },
    async sendQuote({ commit }, info) {
      let id = router.currentRoute.params.id;
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/quote/send_quote/${id}/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          commit("quoteSended", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 404) {
          swal({
            title: "There is something wrong",
            text: `${err.response.data[1]}`,
            icon: "error",
            dangerMode: true
          });
        } else if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async sendToNonQuote(_, messageId) {
      let body = {
        is_quote: false
      };
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/${messageId}/`,
          body,
          api.getToken()
        );
        // if (response.status === 200) {
        //   commit("sendToNonQuote");
        // }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getMessage({ commit }, messageId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/message-id/${messageId}/`,
          api.getToken()
        );
        if (response.status === 200) {
          commit("setCustomers", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getDataCustomers({ commit, dispatch }, payload) {
      let params = {};
      params.customer = payload.customer;
      params.skip = payload.skip;
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/account/carrier`,
          {
            params: params,
            ...api.getToken()
          }
        );
        if (response.status === 200) {
          commit("setCustomers", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          let route = "quotes/quote/getDataCustomers";
          await dispatch("login/refreshToken", route, {
            root: true
          });
        } else if (err.response.status === 404) {
          return err.response;
        } else if (err.response.status != 200) {
          errorMessage();
        }
      }
    },

    async getCustomersById({ dispatch }, accountId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/account/id/${accountId}`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          let info = {};
          info.route = "quotes/quote/getCustomersById";
          info.accountId = accountId;
          await dispatch("login/refreshToken", info, {
            root: true
          });
        } else if (err.response.status != 200) {
          errorMessage();
        }
      }
    },

    async getModes({ commit, dispatch, getters }, department) {
      let params = {};
      params.department_name = department;
      if (department === "Drayage") {
        return getters["showDrayageModes"];
      } else {
        try {
          let response = await axios.get(
            process.env.VUE_APP_BACK_ROUTE + `/api/tms-mode/revenova/`,
            {
              params: params,
              ...api.getToken()
            }
          );
          if (response.status === 200) {
            commit("sendToNonQuote", response.data);
          }
          return response;
        } catch (err) {
          if (err.response.status == 403) {
            let info = {};
            info.route = "quotes/quote/getModes";
            await dispatch("login/refreshToken", info, {
              root: true
            });
          } else if (err.response.status != 200) {
            errorMessage();
          }
        }
      }
    },

    async failedMessage(_, haulId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/failed-description/?haul_id=${haulId}`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getMessageHistory({ commit }, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/history/?message_id=${info.messageId}`,
          api.getToken()
        );
        if (response.status === 200) {
          commit("setMessageHistory");
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async getHaulId(__, messageId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/${messageId}/hauls/`,
          api.getToken()
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 404) {
          swal({
            title: "There is something wrong",
            text: `${err.response.data[1]}`,
            icon: "error",
            dangerMode: true
          });
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    dataPricingSocket({ commit, state }, haulId) {
      let token = localStorage.getItem("charlie-otr-token");
      const baseDomain = process.env.VUE_APP_BACK_ROUTE;
      const dataPricingRoute = baseDomain + "/prediction-gazelle";
      state.dataPricingSocket = io(dataPricingRoute, {
        path: "/sio/socket.io/",
        transports: ["websocket"],
        query: {
          Authorization: `Bearer ${token}`,
          room_id: haulId
        }
      });
      const data = {};
      data.response = null;
      data.haulId = haulId;
      commit("setDataPricingSocketListener", data);
    },
    async getPredictedCost({ commit }, id) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/prediction?haul_id=${id}&model_name=combination-v0.4.1`,
          api.getToken()
        );
        if (response.status == 200) {
          const data = {};
          data.response = response.data;
          data.haulId = id;
          commit("setDataPricingSocketListener", data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
